import React from 'react'
import { useStaticQuery, graphql, Script } from 'gatsby'

const BidJSScripts = ({ uid }) => {
  const BidJSSearchQuery = useStaticQuery(graphql`
    query BidJSSearchQuery {
      prismicConfig {
        ...PrismicConfigFragment
      }
    }
  `)
  const configData = BidJSSearchQuery.prismicConfig.data
  if (uid === 'auction') return null
  return (
    <>
      <Script
        id='bid-js-config-default'
        dangerouslySetInnerHTML={{
          __html: `
          window.bidjs = {
            config: {
              clientId: '${process.env.GATSBY_BIDJS_CLIENT_ID}',
              googleMapsApiKey: '${process.env.GATSBY_BIDJS_GOOGLE_API_KEY}',
              region: '${process.env.GATSBY_BIDJS_REGION}',
              server: '${process.env.GATSBY_BIDJS_SERVER}',
            },
            options: {
              allowTitleChange: false,
              allowMetaDescriptionChange: false,
              analyticsCode: '${process.env.GATSBY_COMPANY_GA}',
              analyticsNamespace: 'app',
              defaultModule: 'empty',
              enablePaginationTop: true,
              urlPattern: 'pushState',
              imageCropMode: 'pad',
              imagePadColor: 'rgb:ffffff',
              itemsPerPageDefault: 24,
              scrollOnNavigationElementId: '___gatsby',
              searchPlaceholder: '${configData.search || 'Search'}',
              standalone: false,
              unsupportedBrowserMessage: 'Your browser is not supported. Please use a browser such as Google Chrome or Microsoft Edge to ensure full functionality',
            },
            modules: {
              auctionDetails: false,
              auctionsArchived: false,
              invoices: false,
              lotDetails: '/auction/#!/auctions/%AUCTION_ID%/listings/%ITEM_ID%',
              marketplaceLotDetails: '/auction/#!/marketplace/listings/%ITEM_ID%',
              mySales: false,
              webcast: false,
              login: false,
              register: false
            }
          }
        `
        }}
      />
      <div className='bidlogix-app bidjs-app hidden'>
        <div id='bidlogix-modal' />
      </div>
      <div className='bidlogix-app hidden'>
        <div id='bidjs' className='bidjs-app relative' />
      </div>
    </>
  )
}

export default BidJSScripts
